/**
 * Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
 *
 *  Portal - Company Profile View
 */
import React from 'react';
import { Switch, Route, matchPath } from 'react-router-dom';
import { observer } from 'mobx-react';
import { useStores } from 'stores/RootStore';

// Design System
import { makeStyles } from '@material-ui/core/styles';
import withWidth, { isWidthUp } from '@material-ui/core/withWidth';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import TabPanel from 'components/CompanyProfile/TabPanel';
import TabLabel from 'components/CompanyProfile/TabLabel';
import Profile from 'components/CompanyProfile/Profile';
import Locations from 'components/CompanyProfile/Locations';
import Users from 'components/CompanyProfile/Users';
import BadgeHistory from 'components/CompanyProfile/BadgeHistory';

const tabRouter = {
  0: {
    tabIndex: 0,
    match: '/company/profile',
    route: 'profile',
  },
  1: {
    tabIndex: 1,
    match: '/company/locations',
    route: 'locations',
  },
  2: {
    tabIndex: 2,
    match: '/company/users',
    route: 'users',
  },
  3: {
    tabIndex: 3,
    match: '/company/badge-history',
    route: 'badge-history',
  },
};

const CompanyProfile = props => {
  const classes = styles();
  const stores = useStores();
  const [value, setTab] = React.useState(0);

  const handleChange = (event, tab) => {
    event.preventDefault();
    props.history.push(tabRouter[tab].route);
  };

  const routeToTab = () => {
    Object.keys(tabRouter).forEach(key => {
      const match = matchPath(props.location.pathname, {
        path: tabRouter[key].match,
        exact: true,
        strict: false,
      });

      if (match) {
        if (value !== tabRouter[key].tabIndex) {
          setTab(tabRouter[key].tabIndex);
        }
      }
    });
  };

  // Set page title
  stores.appStore.setPage('Company');

  // Set tab based on route
  routeToTab();

  return (
    <div className={classes.root}>
      <Tabs
        orientation={isWidthUp('sm', props.width) ? 'vertical' : 'horizontal'}
        indicatorColor='primary'
        value={value}
        onChange={handleChange}
        className={classes.tabs}
      >
        <Tab label={<TabLabel label='Profile' variant='inherit' />} />
        <Tab label={<TabLabel label='Locations' variant='inherit' />} />
        <Tab label={<TabLabel label='Users' variant='inherit' />} />
        <Tab label={<TabLabel label='Badge History' variant='inherit' />} />
      </Tabs>
      <Switch>
        <Route path='/company/profile'>
          <TabPanel title='Company Profile' value={value} index={0} className={classes.tabPanel}>
            <Profile {...props} />
          </TabPanel>
        </Route>
        <Route path='/company/Locations'>
          <TabPanel title='Company Locations' value={value} index={1} className={classes.tabPanel}>
            <Locations {...props} />
          </TabPanel>
        </Route>
        <Route path='/company/users'>
          <TabPanel title='Company Users' value={value} index={2} className={classes.tabPanel}>
            <Users {...props} />
          </TabPanel>
        </Route>
        <Route path='/company/badge-history'>
          <TabPanel title='Badge History' value={value} index={3} className={classes.tabPanel}>
            <BadgeHistory {...props} />
          </TabPanel>
        </Route>
      </Switch>
    </div>
  );
};

const styles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up('sm')]: {
      flexGrow: 1,
      display: 'flex',
      minHeight: '400px',
      height: '100%',
    },
  },
  tabs: {
    minHeight: '100%',
    minWidth: '140px',
    borderRight: `1px solid ${theme.palette.divider}`,
    paddingTop: '15px',
    [theme.breakpoints.down('xs')]: {
      borderRight: '0px',
    },
  },
}));

export default withWidth()(observer(CompanyProfile));
